import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Grid, Switch, FormControlLabel, CircularProgress
} from "@material-ui/core";
import API from "../../../../network/dashboardAPI";
import useAlert from "../../../../services/useAlert";

export default function DeliveryCompanyDialog({ open, onClose, onSaved, initialData }) {
  const alert = useAlert();
  const isEdit = !!initialData?.id;
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: "", code: "", contact_phone: "", contact_email: "",
    website: "", logo_url: "", is_active: true,
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      if (initialData) {
        setForm({
          name: initialData.name || "",
          code: initialData.code || "",
          contact_phone: initialData.contact_phone || "",
          contact_email: initialData.contact_email || "",
          website: initialData.website || "",
          logo_url: initialData.logo_url || "",
          is_active: initialData.is_active !== undefined ? initialData.is_active : true,
        });
      } else {
        setForm({ name: "", code: "", contact_phone: "", contact_email: "", website: "", logo_url: "", is_active: true });
      }
      setErrors({});
    }
  }, [open, initialData]);

  const validate = () => {
    const errs = {};
    if (!form.name.trim()) errs.name = "Name is required";
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSave = async () => {
    if (!validate()) return;
    setLoading(true);
    try {
      const payload = { ...form };
      let response;
      if (isEdit) {
        payload.id = initialData.id;
        response = await API.updateDeliveryCompany(payload);
      } else {
        response = await API.addDeliveryCompany(payload);
      }
      const res = await response.json();
      if (res.success) {
        alert.toast(isEdit ? "Delivery company updated" : "Delivery company created", "success");
        onSaved();
        onClose();
      } else {
        alert.error("Error", res.data || "Failed to save");
      }
    } catch (error) {
      alert.error("Error", "Failed to save delivery company");
    }
    setLoading(false);
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isEdit ? "Edit Delivery Company" : "Add Delivery Company"}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} style={{ marginTop: 8 }}>
          <Grid item xs={12}>
            <TextField
              label="Name *"
              fullWidth
              value={form.name}
              onChange={(e) => handleChange("name", e.target.value)}
              error={!!errors.name}
              helperText={errors.name}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Code"
              fullWidth
              value={form.code}
              onChange={(e) => handleChange("code", e.target.value)}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Contact Phone"
              fullWidth
              value={form.contact_phone}
              onChange={(e) => handleChange("contact_phone", e.target.value)}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Contact Email"
              fullWidth
              value={form.contact_email}
              onChange={(e) => handleChange("contact_email", e.target.value)}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Website"
              fullWidth
              value={form.website}
              onChange={(e) => handleChange("website", e.target.value)}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Logo URL"
              fullWidth
              value={form.logo_url}
              onChange={(e) => handleChange("logo_url", e.target.value)}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={form.is_active}
                  onChange={(e) => handleChange("is_active", e.target.checked)}
                  color="primary"
                />
              }
              label="Active"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" color="primary" disabled={loading}>
          {loading ? <CircularProgress size={20} /> : isEdit ? "Update" : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
